import { orderMethodsState } from 'components/pages/dashboard/ParcelOrder/ParcelOrder';
import { GetServicesInRoute, ltlPallet, ltlPalletCreate, ltlPayload, omOrderPackage, omOrderServices, orderCost, orderPaylaod, packageCreate } from 'global/Models/omOrderModel';
import { priceTypeBranch } from '../../parcelOrderForBranch/components copy/BranchOrder/BranchParcelOrderPrice';

export const getPayloadFromPackages = (
  packages: packageCreate[],
  orderMethods: orderMethodsState,
  orderServices: GetServicesInRoute[][],
  cashAmountCashAndPayInPlace: number | undefined
): orderPaylaod => {
  let paymentTypeId = orderMethods.paymentTypeId;
  //each packages have an array of package which have a count property, i need sum of packages.package.count properties
  const parcelCount = packages.reduce((total, obj) => {
    return total + obj.package.reduce((total, obj) => total + (obj.count || 1), 0);
  }, 0);

  if (parcelCount === 0) return {} as orderPaylaod;

  let cashAmount: number | string | undefined = undefined;

  if (orderMethods.paymentTypeId == 70) {
    if (!orderMethods.cashAmount) {
      cashAmount = 0;
    } else {
      try {
        const amount = parseInt(orderMethods.cashAmount + '');
        if (amount > 0) cashAmount = amount / parcelCount;
        else cashAmount = 0;
      } catch (_error) {
        cashAmount = 0;
      }
    }
    if (cashAmount === 0 || cashAmount === undefined) {
      paymentTypeId = 20;
      cashAmount = undefined;
    }
  }

  if (orderMethods.paymentTypeId == 100) {
    cashAmount = cashAmountCashAndPayInPlace;
  }

  const findGroupForOrder = (ord: packageCreate): GetServicesInRoute[] | undefined => {
    if (!Array.isArray(orderServices) || orderServices.length === 0) return undefined;

    const senderTitle = ord.senderAddress?.address?.cityTitle;
    const receiverTitle = ord.receiverAddress?.address?.cityTitle;

    const matchByTitle = orderServices.find((grp) => {
      const g0 = grp?.[0];
      if (!g0) return false;
      return g0.origingCityTitle === senderTitle && g0.destinationCityTitle === receiverTitle;
    });

    return matchByTitle ?? orderServices[0];
  };

  const pickServiceFromGroup = (grp?: GetServicesInRoute[]) => {
    if (!grp || grp.length === 0) return { serviceId: undefined as number | undefined, timeWindowId: undefined as number | string | undefined };

    const selected = grp.find((s) => s.selected) ?? grp[0];
    const selectedTwId = selected?.timeWindows?.find((tw) => tw.selected)?.id;

    return {
      serviceId: selected?.serviceId,
      timeWindowId: selectedTwId,
    };
  };

  const payload: omOrderPackage[] = [];
  // loop in order rows
  for (let i = 0; i < packages.length; i++) {
    const order = packages[i];
    // loop in packages added to order
    for (let k = 0; k < (order.package.length || 1); k++) {
      const packaging = order.package[k];
      // loop [count] times
      for (let p = 0; p < (packaging.count || 1); p++) {
        // NEW: choose service based on the matching group (origin/destination) for this order
        const grp = findGroupForOrder(order);
        const { serviceId, timeWindowId } = pickServiceFromGroup(grp);

        payload.push({
          senderClientId: order.senderClient?.id as number,
          receiverClientId: order.receiverClient?.id as number,
          senderAddressId: order.senderAddress?.address.id as number,
          receiverAddressId: order.receiverAddress?.address.id as number,
          destinationCityId: !!order.receiverAddress?.address.id || !order.lockerInfo ? undefined : order.lockerInfo.cityId,
          enableLabelPrivacy: false,
          // weight: packaging?.weight as number,
          // packageValue: packaging?.price as number,
          // width: packaging?.width as number,
          // length: packaging?.length as number,
          // height: packaging?.height as number,
          // packagingTypeId: packaging?.packagingTypeId as number,
          // packageContentId: packaging?.packagingContentId as number,
          // packagingGroupId: packaging?.packagingGroupId || 20,
          customerPackageId: packaging?.id as number,
          description: packaging?.description || '',
          products:
            packaging?.productTypes?.slice(0, 5).map((item) => ({ id: item.customerProductId ?? item.id, branchId: item.branchId ?? null, count: item.count })) || undefined,
          serviceId: serviceId as number,
          paymentTypeId: paymentTypeId as number,
          cod: orderMethods.haveCOD ? (packaging?.cod ? packaging.cod : packaging.price) : undefined,
          pickupTypeId: orderMethods.pickupTypeId as number,
          deliveryTypeId: orderMethods.deliveryTypeId as number,
          pickupDate: orderMethods.selectedDate as string,
          pickupStartTime: orderMethods.selectedFromHour as string,
          pickupEndTime: orderMethods.selectedToHour as string,
          customerSubstationCode: orderMethods.customerSubstationCode as string,
          cashAmount,
          timeWindowId,
        });
      }
    }
  }

  return {
    packages: payload,

    confirmLockerOrder: {
      orderNumber: packages[0].lockerInfo?.orderNumber as string,
      trackNumber: packages[0].lockerInfo?.trackNumber as string,
      barcode: packages[0].lockerInfo?.barcode as string,
      // payType: packages[0].lockerInfo?.payType as string,
    },
  };
};

export const getPricingLTLPayload = (packages: ltlPalletCreate[], _orderMethods: orderMethodsState) => {
  const packageInputs = packages
    .map((order, _index) => {
      return order.pallets.map((pallet) => {
        return {
          origin: {
            cityId: order.senderAddress?.address.cityETipaxId,
          },
          destination: {
            cityId: order.receiverAddress?.address.cityETipaxId,
          },
          weight: pallet.palletDetail.palletWeight,
          packageValue: pallet.palletDetail.parcelValue,
          length: pallet.palletDetail.palletLength,
          width: pallet.palletDetail.palletWidth,
          height: pallet.palletDetail.palletHeight,
          packingId: pallet.package?.[0]?.packagingTypeId,
          isUnusual: true,
          packType: 40,
          paymentType: 10,
          pickupType: 10,
          distributionType: 10,
          serviceId: 10,
        };
      });
    })
    .flat();

  return {
    packageInputs,
  };
};

export const getOrderCostFinalAmount = (cost: orderCost): number => {
  const finalAmount = cost.finalAmount ?? (cost as orderCost & { FinalAmount?: number | null }).FinalAmount;
  return typeof finalAmount === 'number' ? finalAmount : 0;
};

export const getOrderCostOriginalFinalAmount = (cost: orderCost): number | null | undefined => {
  return cost.originalFinalAmount ?? (cost as orderCost & { OriginalFinalAmount?: number | null }).OriginalFinalAmount;
};

export const sumFinalAmounts = (arr: orderCost[]): number => {
  return arr.reduce((total, obj) => {
    return total + getOrderCostFinalAmount(obj);
  }, 0);
};

export const sumOriginalFinalAmounts = (arr: orderCost[]): number | undefined => {
  let hasOriginalFinalAmount = false;

  const total = arr.reduce((sum, cost) => {
    const originalFinalAmount = getOrderCostOriginalFinalAmount(cost);
    if (originalFinalAmount !== null && originalFinalAmount !== undefined) {
      hasOriginalFinalAmount = true;
      return sum + originalFinalAmount;
    }

    return sum + getOrderCostFinalAmount(cost);
  }, 0);

  return hasOriginalFinalAmount ? total : undefined;
};

export const sumBranchFinalAmounts = (arr: priceTypeBranch[]): number => {
  return arr.reduce((total, obj) => {
    if (obj.regularRate?.finalPrice) {
      return total + obj.regularRate.finalPrice;
    } else {
      return total;
    }
  }, 0);
};

export const orderCODSum = (packages: packageCreate[]) => {
  let total = 0;
  for (let i = 0; i < packages.length; i++) {
    const order = packages[i];
    for (let k = 0; k < order.package.length; k++) {
      const pack = order.package[k];
      const price = pack.cod || pack.price;
      if (!pack.count) total += +price;
      else total += +price * parseInt(pack.count + '');
    }
  }
  return total;
};

export const ltlOrderCODSum = (packages: ltlPalletCreate[]) => {
  let total = 0;
  for (let i = 0; i < packages.length; i++) {
    const order = packages[i];
    for (let k = 0; k < order.pallets.length; k++) {
      const pallet = order.pallets[k];
      const palletCount = pallet.palletDetail.palletCount || 1;
      for (let p = 0; p < pallet.package.length; p++) {
        const pack = pallet.package[p];
        const price = pack.cod || pack.price;
        const count = pack.count || 1;
        total += +price * count * palletCount;
      }
    }
  }
  return total;
};

export const getOrderSteps = (packages: packageCreate[], currentStep: number) => [
  {
    title: 'اطلاعات سفارش',
    subTitle: packages.length + ' سفارش',
    description:
      currentStep !== 0 ? (
        <div className='flex flex-col text-[10px] inherit-colorf !text-t-text-color'>
          {packages.map((item, index) => {
            if (!item.senderAddress?.address.cityTitle) return null;
            return (
              <span key={item.uuid} className='!text-t-text-color'>
                {index + 1}
                {' - '}
                {item.senderAddress?.address.cityTitle}
                {' --> '}
                {item.package?.length} بسته{' --> '}
                {item.receiverAddress?.address.cityTitle}
              </span>
            );
          })}
        </div>
      ) : (
        <div className='flex'>
          <span className='text-[10px]'>اطلاعات محل جمع آوری و توزیع و بسته ارسالی</span>
        </div>
      ),
  },
  {
    title: 'طریقه پرداخت و ارسال',
    subTitle: '',
    description: '',
  },
  {
    title: 'بازبینی و تایید',
    subTitle: '',
    description: '',
  },
];

export const getLTLOrderSteps = (packages: ltlPalletCreate[], currentStep: number) => [
  {
    title: 'اطلاعات سفارش بار سنگین',
    subTitle: packages.length + ' سفارش',
    description:
      currentStep !== 0 ? (
        <div className='flex flex-col text-[10px] inherit-colorf !text-t-text-color'>
          {packages.map((item, index) => {
            if (!item.senderAddress?.address.cityTitle) return null;
            return (
              <span key={item.uuid} className='!text-t-text-color'>
                {index + 1}
                {' - '}
                {item.senderAddress?.address.cityTitle}
                {' --> '}
                {item.pallets?.length} باکس لاین{' --> '}
                {item.receiverAddress?.address.cityTitle}
              </span>
            );
          })}
        </div>
      ) : (
        <div className='flex'>
          <span className='text-[10px]'>اطلاعات محل جمع آوری و توزیع و باکس لاین ارسالی</span>
        </div>
      ),
  },
  {
    title: 'طریقه پرداخت و ارسال',
    subTitle: '',
    description: '',
  },
  {
    title: 'بازبینی و تایید',
    subTitle: '',
    description: '',
  },
];

export const getLTLOrderPayload = (packages: ltlPalletCreate[], orderMethods: orderMethodsState, orderServices: omOrderServices): ltlPayload => {
  let paymentTypeId = orderMethods.paymentTypeId;

  // Calculate total pallet count across all packages
  const palletCount = packages.reduce((total, obj) => {
    return total + obj.pallets.reduce((total, pallet) => total + (pallet.palletDetail.palletCount || 1), 0);
  }, 0);

  if (palletCount === 0) {
    return {
      pickupDate: orderMethods.selectedDate as string,
      pallets: [],
      traceCode: '',
      secondaryTraceCode: '',
      customerSubstationCode: orderMethods.customerSubstationCode as string,
      discountCode: '',
      confirmLockerOrder: {
        orderNumber: '',
        trackNumber: '',
        barcode: '',
        payType: '',
      },
    };
  }

  let cashAmount: number | string | undefined = undefined;

  // Handle cash payment logic similar to getPayloadFromPackages
  if (orderMethods.paymentTypeId == 70) {
    if (!orderMethods.cashAmount) {
      cashAmount = 0;
    } else {
      try {
        const amount = parseInt(orderMethods.cashAmount + '');
        if (amount > 0) cashAmount = amount / palletCount;
        else cashAmount = 0;
      } catch (_error) {
        cashAmount = 0;
      }
    }
    if (cashAmount === 0 || cashAmount === undefined) {
      paymentTypeId = 20;
      cashAmount = undefined;
    }
  }

  const payload: ltlPallet[] = [];

  // Loop through LTL packages
  for (let i = 0; i < packages.length; i++) {
    const order = packages[i];

    // Loop through pallets in each order
    for (let k = 0; k < order.pallets.length; k++) {
      const pallet = order.pallets[k];

      // Loop for pallet count
      for (let p = 0; p < (pallet.palletDetail.palletCount || 1); p++) {
        const jetService = orderServices.find(
          (service) =>
            service.destCityId.toLowerCase() === order.destinationCity?.jetId?.toLowerCase() && service.sourceCityId.toLowerCase() === order.sourceCity?.jetId?.toLowerCase()
        );

        let serviceId = jetService?.serviceList[0].serviceId || orderMethods.serviceId;
        if (jetService) {
          jetService.serviceList.map((service) => {
            if (service.selected) serviceId = service.serviceId;
          });
        }

        // Calculate total weight and value from packages in the pallet
        const totalWeight = pallet.package?.map((pack) => pack.weight * (pack?.count ? pack?.count : 1)).reduce((a, b) => a + b, 0) || 0;

        const totalValue = pallet.package?.map((pack) => (pack.price || 0) * (pack?.count ? pack?.count : 1)).reduce((a, b) => a + b, 0) || 0;

        // Map packages within the pallet to ltlPackage format
        const ltlPackages =
          pallet.package?.map((pack) => ({
            weight: pack.weight || 0,
            packageValue: pack.price || 0,
            length: pack.length || 0,
            width: pack.width || 0,
            height: pack.height || 0,
            packagingTypeId: pack.packagingTypeId || 0,
            packageContentId: pack.packagingContentId || 0,
            packagingGroupId: pack.packagingGroupId || 20,
            parcelTypeId: 10, // Default LTL parcel type
            customerPackageId: pack.id || 0,
            description: pack.description || '',
            serviceId: serviceId as number,
            enableLabelPrivacy: false,
            paymentTypeId: paymentTypeId as number,
            pickupTypeId: orderMethods.pickupTypeId as number,
            deliveryTypeId: orderMethods.deliveryTypeId as number,
            pickupDate: orderMethods.selectedDate as string,
            pickupStartTime: orderMethods.selectedFromHour as string,
            pickupEndTime: orderMethods.selectedToHour as string,
            cod: orderMethods.haveCOD ? (pack?.cod ? pack.cod : pack.price) : 0,
            cashAmount: cashAmount as number,
            parcelFounderId: 0,
            parcelPaymentTypeId: paymentTypeId as number,
            barcode: '',
            customParcelTitle: '',
          })) || [];

        payload.push({
          packages: ltlPackages,
          senderClientId: order.senderClient?.id as number,
          receiverClientId: order.receiverClient?.id as number,
          senderAddressId: order.senderAddress?.address.id as number,
          receiverAddressId: order.receiverAddress?.address.id as number,
          sourceCityId: order.sourceCity?.id as number,
          destinationCityId: order.destinationCity?.id as number,
          weight: totalWeight,
          packageValue: totalValue,
          length: pallet.palletDetail.palletLength || 0,
          width: pallet.palletDetail.palletWidth || 0,
          height: pallet.palletDetail.palletHeight || 0,
          packagingTypeId: pallet.package?.[0]?.packagingTypeId || 0,
          packageContentId: pallet.package?.[0]?.packagingContentId || 0,
          packagingGroupId: 20, // Default LTL packaging group
          parcelTypeId: 10, // Default LTL parcel type
          customerPackageId: 0, // No ID available in palletDetail
          description: '', // No description available in palletDetail
          serviceId: serviceId as number,
          enableLabelPrivacy: false,
          paymentTypeId: paymentTypeId as number,
          pickupTypeId: orderMethods.pickupTypeId as number,
          deliveryTypeId: orderMethods.deliveryTypeId as number,
          pickupDate: orderMethods.selectedDate as string,
          pickupStartTime: orderMethods.selectedFromHour as string,
          pickupEndTime: orderMethods.selectedToHour as string,
          cod: orderMethods.haveCOD ? totalValue : 0,
          cashAmount: cashAmount as number,
          parcelFounderId: 0,
          parcelPaymentTypeId: paymentTypeId as number,
          barcode: '',
          customParcelTitle: '',
        });
      }
    }
  }

  return {
    pickupDate: orderMethods.selectedDate as string,
    pallets: payload,
    traceCode: '',
    secondaryTraceCode: '',
    customerSubstationCode: orderMethods.customerSubstationCode as string,
    discountCode: '',
    confirmLockerOrder: {
      orderNumber: '',
      trackNumber: '',
      barcode: '',
      payType: '',
    },
  };
};

export function removeSenderNationalIdRequiredFromQuery(index: number, removeQuery: (_arg: any) => void) {
  removeQuery({ [`senderNationalIdIsRequired-${index}`]: undefined });
}
